import { register, getPrefix, attachScripts } from '../../../Utils'

const ImageCompare = el => {
  const prefix = getPrefix(el)
  const scripts = [
    'https://unpkg.com/image-compare-viewer/dist/image-compare-viewer.min.js' // lokal hosten
  ]

  const initViewer = () => {
    let ImageCompare = window.ImageCompare
    const container = el.querySelector(`.${prefix}compare-container`)
    const labelBefore = el.dataset.before
    const labelAfter = el.dataset.after

    const compareOptions = {
      controlColor: '#40A6A9',
      controlShadow: false,
      addCircle: true,
      showLabels: labelBefore && labelAfter,
      labelOptions: {
        before: labelBefore,
        after: labelAfter
      }
    }

    new ImageCompare(container, compareOptions).mount() // var assignment remove, add again if conflict when more than 1 viewers
  }

  if (typeof window.ImageCompare !== 'undefined') {
    initViewer()
  } else {
    attachScripts(scripts, el, initViewer)
  }
}

register('ImageCompare', ImageCompare)
